import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Forbidden() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <SEO
        title="Ingen adgang - Power-Multiservice"
        description="Du har ikke adgang til denne side på Power-Multiservice."
      />

      <div className="max-w-lg w-full text-center bg-white p-8 sm:p-12 border border-slate-200 shadow-xl space-y-6">
        <div className="w-20 h-20 bg-amber-50 text-amber-700 flex items-center justify-center mx-auto text-3xl font-black">
          403
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl sm:text-3xl font-black text-slate-900 tracking-tight">
            Ingen adgang
          </h1>
          <p className="text-slate-600 text-sm leading-relaxed">
            Du har desværre ikke tilladelse til at tilgå denne side. Benyt venligst linkene herunder for at navigere videre.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2">
          <Link
            to="/"
            className="w-full sm:w-auto px-6 py-3 rounded-full font-bold text-sm text-white bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto px-6 py-3 rounded-full font-bold text-sm text-slate-700 bg-slate-100 hover:bg-slate-200 transition-all flex items-center justify-center gap-2"
          >
            <span>Kontakt os</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
